<template>


  <content-with-sidebar class="blog-wrapper">

    <div class="row" v-if="Object.keys(blogList).length">
      <div class="col-md-6 col-12"  v-for="(blog,index) in blogList" :key="index">
          <div class="card">
              <a href="#">
                  <img class="card-img-top img-fluid" :src='blog.blobImage' alt="">
              </a>
              <div class="card-body">
                  <h4 class="card-title">
                      <a :href="'/blog/'+blog.category+'/'+blog.slug"  class="blog-title-truncate text-body-heading">{{ blog.blogtitle }}</a>
                  </h4>
                  <div class="d-flex">
                      <div class="avatar mr-75">
                        <div v-if="userClass" @load="randClass" class="avatar-content avatar-xl" :class="userClass" height="38" width="38">
                          <span class="avatar-content">{{blog.authorAbv}}</span></div>
                          <!-- <img src="/assets/images/portrait/small/avatar-s-6.jpg" alt="Avatar" width="38" height="38"> -->
                      </div>
                      <div class="author-info ml-75">
                          <small class="text-muted me-25 mr-75"> by</small>
                          <small><a href="#" class="text-body mr-75">{{ blog.author.full_name}}</a></small>
                          <span class="text-muted ms-50 me-25 mr-75">|</span>
                          <small class="text-muted">{{ blog.published_at }}</small>
                      </div>
                  </div>
                  <div class="my-1 py-25">
                      <a href="#" v-for="(tag,index) in blog.tags" :key="index">

                          <span class='badge rounded-pill me-50 mr-75 badge-light-primary' style="margin-bottom:4px;">{{ tag }}</span>

                      </a>
                  </div>
                  <p class="card-text blog-content-truncate" v-html="blog.teaser"/>
                  <hr>
                  <div class="d-flex justify-content-between align-items-center">
                      <a href="#">
                          <div class="d-flex align-items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-message-square font-medium-1 text-body me-50"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                              <span class="text-body fw-bold ml-75">{{ blog.comments_count}}   Comments</span>
                          </div>
                      </a>
                      <a :href="'/blog/'+blog.category+'/'+blog.slug" class="fw-bold">Read More</a>
                  </div>
              </div>
          </div>
      </div>
      <b-col cols="12">
        <!-- pagination -->
        <div class="my-2 d-flex justify-content-center">
              <pagination v-model="currentPage" :records="rows" :per-page="perPage" @paginate="list"/>
        </div>

      </b-col>
    </div>
    <div class="row" v-else>
      <div class="col-md-12 col-12">
        <div class="card">
            <div class="card-body">
                <div class="media">
                  <h5>No Posts</h5>
                </div>
            </div>
        </div>
      </div>
    </div>

    <template
      #sidebar
      class="blog-sidebar py-2 py-lg-0"
    >
      <!-- input search -->

        <div class="blog-search">
        <div class="input-group input-group-merge relative">
            <input type="text" class="form-control" placeholder="Search here" v-model="searchVal" @keyup="result"/>
            <div class="input-group-append">
                <span class="input-group-text cursor-pointer">
                    <i data-feather="search"></i>
                </span>
            </div>
        </div>
      </div>
      <!--/ input search -->

      <!-- search result posts -->
      <div class="blog-recent-posts mt-3" :class="displayer">
            <h6 class="section-label">Blog Results Posts</h6>



            <div v-if="Object.keys(searchResult).length">
              <div class="mt-75" v-for="(result,index) in searchResult" :key="index">
                <div class="media mb-2">

                    <a href="#" class="mr-2">
                        <img class="rounded" :src="result.blobImage" width="100" height="70" :alt="result.blobImage.slice(6)" />
                    </a>
                    <div class="media-body">
                        <h6 class="blog-recent-post-title">
                            <a :href="'/blog/'+result.category+'/'+result.slug" class="text-body-heading" style="font-size:12px">{{ result.title }}</a>
                        </h6>
                        <div class="text-muted mb-0" style="font-size:11px">{{ result.published_at }}</div>
                    </div>

                </div>
              </div>
            </div>
            <div v-else>
              <div class="card">
                  <div class="card-body">
                      <div class="media">
                        <h5>No Posts Result</h5>
                      </div>
                  </div>
              </div>
            </div>

        </div>
      <!--/ search result posts -->

      <!-- categories -->
      <div class="mt-3">
        <h6 class="section-label mb-1">
          Categories
        </h6>

        <div
          v-for="category in category"
          :key="category.icon"
          class="d-flex justify-content-start align-items-center mb-75"
        >
         <a :href="'/blog/'+category.category">
            <b-avatar
              rounded
              size="32"
              variant="badge-light-primary"
              class="mr-75 badge-light-primary"
            >
              <vue-feather type='droplet' icon></vue-feather>
            </b-avatar>
          </a>
          <a :href="'/blog/'+category.category">
            <div class="blog-category-title text-body">
              {{ category.category }}
            </div>
          </a>
        </div>
      </div>
      <!--/ categories -->
    </template>
  </content-with-sidebar>
</template>

<script>

import { ChevronLeftIcon,ChevronRightIcon } from 'vue-feather-icons'
import {BLink,BAvatar,BPagination} from 'bootstrap-vue-3'
import ContentWithSidebar from '../../../@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'
import axios from 'axios'
export default {
  name:'AuthorBlogComponent',
  components: {
    ContentWithSidebar,
    BLink,
    BAvatar,
    BPagination,
    ChevronLeftIcon,
    ChevronRightIcon,
  },
  data() {
    return {
      search_query: '',
      blogList: {},
      blogSidebar: {},
      currentPage: 0,
      perPage: 0,
      prevPage:'',
      nextPage:'',
      rows: 0,
      category:{},
      searchVal:'',
      searchfeed:false,
      searchResult:{},
      userClass:''
    }
  },
  // mounted(){
  //   this.list();
  // },
  created() {
    this.list();
    this.randClass()
    this.blogSidebar = {};
  },
  computed:{
    displayer(){
      return this.searchfeed?'showresult':'hideresult';
    }
  },
  methods: {
    result(){
        let params = {
            searchvalue:this.searchVal
        }
        let n = this;
        const route = this.$router.resolve(
            {
                name: 'blog-search',
            }
        );
        axios.get(route.href,{params}).then(({data})=>{
          if(!data.false && data.searchResult !=null){
              n.searchResult = data.searchResult
              n.searchfeed = true
          }else{
            n.searchResult = {}
            n.searchfeed = false
          }
        }).catch(({ response })=>{
            // console.error(response)
            toastr.error(response.message, 'error!');
        })
    },
    async list(page){
        if(typeof page == null || typeof page == undefined){
          page = 1
        }
        let n = this
        await axios.get(`/blog/list?page=${+page}&writer=author`).then(({data})=>{
          if(!data.false){
            let dataCurrent = data.data;
            n.blogList = dataCurrent.data
            n.category = data.category

            n.currentPage = dataCurrent.current_page

            n.perPage = dataCurrent.per_page
            n.prevPage = dataCurrent.prev_page_url
            n.nextPage = dataCurrent.next_page_url
            n.rows = dataCurrent.total
          }

        }).catch(({ response })=>{
            // console.error(response)
            toastr.error(response.message, 'error!');
        })
    },
    randClass(){
      var classes = ['bg-light-primary','bg-light-secondary','bg-light-success','bg-light-danger'];
      var  newClass = Math.floor(Math.random() * classes.length);
      this.userClass=classes[newClass]
    },

  },
}
</script>

<style lang="scss">
@import '../../../../sass/vue/pages/page-blog.scss';
.buttonCreate{
  height:45px;
  width:120px;
  text-align: center;
  padding-top: 10px;
}

.VuePagination__count{
  display: none;
}
.hideresult{
  display:none;
}
.showresult{
  display:block;
}
</style>
